import { uniqueId } from 'lodash';
import { EditableUserInputtedCriteriaData, EditableCriteria } from '../types';

export const createBlankCriteria = ({
  combinator,
  searchQueries = [],
}: EditableUserInputtedCriteriaData = {}): EditableCriteria => ({
  combinator,
  searchQueries,
  id: uniqueId(),
});
